import {
    matchThisOrChildren,
    closest,
    format,
    collectEvent,
} from '../../ApcLoggingService/src/utils/index';

const PAGE = 'globalSearch';
const SEARCH_EVENT = 'clickSearch';
const ENTER_KEY = 13;
const SEARCH_BTN_SELECTOR = '.analytics-navigation';
const PRODUCT_SUGGESTION_SELECTOR = '.analytics-product-suggestion';
const KEYWORD_SUGGESTION_SELECTOR = '.analytics-keyword-suggestion';
const PRODUCT_CATEGORY_SELECTOR = '.analytics-product-category';
const SHOW_ALL_SELECTOR = '.analytics-show-all';
const POPULAR_RESULT_SELECTOR = '.analytics-popular-result';
const SEARCH_INPUT_SELECTOR = 'input.analytics-input';

const getKeyWord = () => {
    const input = document.querySelector(SEARCH_INPUT_SELECTOR);
    return (input && format(input.value)) || '';
};
const sendSearchEvent = collectEvent.bind(null, SEARCH_EVENT);

class GlobalSearchAnalytics {
    constructor() {
        this.BLOCK = null;
    }
    init() {
        this.BLOCK = document.querySelector('body');
        this.INPUT = document.querySelector('.analytics-input');
        if (this.BLOCK) {
            this.BLOCK.addEventListener('click', this.handleGlobalSearchPage, true);
        }
        if (this.INPUT) {
            this.BLOCK.addEventListener('keydown', this.handleInputKeyDown, true);
        }
    }

    handleInputKeyDown = e => {
        if (e.keyCode === ENTER_KEY) {
            this.navigation(e);
        }
    };
    getValueFromDataset(elem, attribute) {
        const name = elem ? elem.dataset[attribute] || '' : '';
        return format(name);
    }

    handleGlobalSearchPage = e => {
        const { target } = e;
        if (matchThisOrChildren(target, SEARCH_BTN_SELECTOR)) {
            this.navigation(target);
        } else if (matchThisOrChildren(target, PRODUCT_SUGGESTION_SELECTOR)) {
            this.productSuggestion(target);
        } else if (matchThisOrChildren(target, KEYWORD_SUGGESTION_SELECTOR)) {
            this.keywordSuggestion(target);
        } else if (matchThisOrChildren(target, PRODUCT_CATEGORY_SELECTOR)) {
            this.productCategory(target);
        } else if (matchThisOrChildren(target, SHOW_ALL_SELECTOR)) {
            this.showAll(target);
        } else if (matchThisOrChildren(target, POPULAR_RESULT_SELECTOR)) {
            this.popularResult(target);
        }
    };

    productSuggestion(target) {
        const block = closest(target, PRODUCT_SUGGESTION_SELECTOR);
        this.apcLogService(`${PAGE}.productSuggestion.click`, {
            productId: this.getValueFromDataset(block, 'productId'),
            target: block,
            keyword: getKeyWord(),
        });
    }
    keywordSuggestion(target) {
        const block = closest(target, KEYWORD_SUGGESTION_SELECTOR);
        this.apcLogService(`${PAGE}.keywordSuggestion.click`, {
            name: this.getValueFromDataset(block, 'itemName'),
            target: block,
            keyword: getKeyWord(),
        });
    }
    productCategory(target) {
        const block = closest(target, PRODUCT_CATEGORY_SELECTOR);
        this.apcLogService(`${PAGE}.productCategory.click`, {
            name: this.getValueFromDataset(block, 'itemName'),
            target: block,
            keyword: getKeyWord(),
        });
    }
    showAll(target) {
        const block = closest(target, SHOW_ALL_SELECTOR);
        this.apcLogService(`${PAGE}.showAll.click`, {
            target: block,
            keyword: getKeyWord(),
        }); // 3 - 4th;`
    }

    popularResult(target) {
        const block = closest(target, POPULAR_RESULT_SELECTOR);
        this.apcLogService(`${PAGE}.popularResult.click`, {
            name: this.getValueFromDataset(block, 'itemName'),
            target: block,
            keyword: getKeyWord(),
        }); // 3 - 4th;`
    }

    navigation(target) {
        const input = document.querySelector(SEARCH_INPUT_SELECTOR);
        if (input && input.value) {
            const block = closest(target, SEARCH_BTN_SELECTOR);
            this.apcLogService(`${PAGE}.navigation.click`, {
                target: block,
                keyword: format(input.value),
            }); // 4 - 4th;
        }
    }
    apcLogService(type, data) {
        switch (type) {
            case 'globalSearch.keywordSuggestion.click':
                sendSearchEvent(data.target, {
                    event_level: '12',
                    event_name: `Guided-Search-Keyword-suggestion_${data.name}_${data.keyword}`,
                    event_cat1: 'Guided-Search-Keyword-suggestion',
                    event_cat2: data.name,
                    event_cat3: data.keyword,
                    event_type: 'action',
                });
                break;
            // 2 - 5th
            case 'globalSearch.productSuggestion.click':
                sendSearchEvent(data.target, {
                    event_level: '12',
                    event_name: `Guided-Search-Product-suggestion_P-${data.productId}_${
                        data.keyword
                    }`,
                    event_cat1: 'Guided-Search-Product-suggestion',
                    event_cat2: `P-${data.productId}`,
                    event_cat3: data.keyword,
                    event_type: 'navigation',
                });
                break;
            // new categories
            case 'globalSearch.productCategory.click':
                sendSearchEvent(data.target, {
                    event_level: '12',
                    event_name: `Guided-Search-Product-categories_${data.name}_${data.keyword}`,
                    event_cat1: 'Guided-Search-Product-categories',
                    event_cat2: data.name,
                    event_cat3: data.keyword,
                    event_type: 'navigation',
                });
                break;
            // 3 -5th
            case 'globalSearch.showAll.click':
                sendSearchEvent(data.target, {
                    event_level: '12',
                    event_cat1: 'Search-Show-all-results',
                    event_cat2: '',
                    event_cat3: data.keyword,
                    event_name: `Search-Show-all-results_${data.keyword}`,
                    event_type: 'action',
                });
                break;
            // 4 - 5th
            case 'globalSearch.navigation.click':
                sendSearchEvent(data.target, {
                    event_level: '12',
                    event_cat1: 'Search',
                    event_cat2: '',
                    event_cat3: data.keyword,
                    event_name: `Search_${data.keyword}`,
                    event_type: 'action',
                });
                break;
            case 'globalSearch.popularResult.click':
                sendSearchEvent(data.target, {
                    event_level: '12',
                    event_cat1: 'Popular-Search',
                    event_cat2: data.name,
                    event_cat3: '',
                    event_name: `Popular-Search_${data.name}`,
                    event_type: 'action',
                });
                break;

            default:
                break;
        }
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', () => {
        new GlobalSearchAnalytics().init();
    });
} else {
    new GlobalSearchAnalytics().init();
}
